import React from 'react';

import DarkenBackground from '../components/ui/DarkenBackground';
import { useTranslation } from 'react-i18next';
import { COMMON_TRANSLATE_KEYS } from '../constants/translate-keys';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <DarkenBackground className="relative h-screen flex justify-center ">
      <div className="z-20 flex w-full items-center">
        <h3 className="flex w-full text-center text-white justify-center text-3xl font-semibold font-montserrat">
          {t(COMMON_TRANSLATE_KEYS.PAGE_NOT_FOUND)}
        </h3>
      </div>
    </DarkenBackground>
  );
};

export default NotFound;
